import { useEffect, useState } from 'react';
import { zohoAPI } from '../../lib/api';

export default function ZohoSyncStamp({ className = '', entity = null }) {
  const [asOf, setAsOf] = useState(null);

  useEffect(() => {
    let active = true;
    zohoAPI.getSyncStatus()
      .then((res) => {
        if (!active) return;
        if (entity) {
          const match = res.data.entities.find((e) => e.entity === entity);
          setAsOf(match?.last_success_at || null);
        } else {
          setAsOf(res.data.oldest_success_at);
        }
      })
      .catch(() => {});
    return () => { active = false; };
  }, [entity]);

  if (!asOf) return null;

  return (
    <p className={`text-xs text-muted-foreground ${className}`} data-testid="zoho-data-as-of">
      Zoho data as of {new Date(asOf).toLocaleString()}
    </p>
  );
}
